module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Select flag for language: {language}":"Select flag for language: {language}"},"de":{"Localization":"Mehrsprachigkeit","Languages":"Sprachen","Language":"Sprache","Active":"Aktiv","Flag":"Flagge","Default Language":"Standardsprache","Select flag for language: {language}":"Flagge für Sprache \\"{language}\\" auswählen","Cancel":"Abbrechen","Ok":"Ok"}}')
  delete Component.options._Ctor
}
